import types from '../mutation-types';
import CrmConfigsAPI from '../../api/crmConfigs';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  get: async ({ commit }) => {
    commit(types.SET_CRM_CONFIG_UI_FLAG, { fetchingList: true });
    try {
      const response = await CrmConfigsAPI.get();
      commit(types.SET_CRM_CONFIGS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CRM_CONFIG_UI_FLAG, { fetchingList: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_CRM_CONFIG_UI_FLAG, { creatingItem: true });
    try {
      const response = await CrmConfigsAPI.create(data);
      commit(types.ADD_CRM_CONFIG, response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CRM_CONFIG_UI_FLAG, { creatingItem: false });
    }
  },
  update: async ({ commit }, { id, ...data }) => {
    commit(types.SET_CRM_CONFIG_UI_FLAG, { updatingItem: true });
    try {
      const response = await CrmConfigsAPI.update(id, data);
      commit(types.EDIT_CRM_CONFIG, response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CRM_CONFIG_UI_FLAG, { updatingItem: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CRM_CONFIG_UI_FLAG, { deletingItem: true });
    try {
      await CrmConfigsAPI.delete(id);
      commit(types.DELETE_CRM_CONFIG, id);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_CRM_CONFIG_UI_FLAG, { deletingItem: false });
    }
  },
};

const mutations = {
  [types.SET_CRM_CONFIG_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CRM_CONFIGS](_state, data) {
    _state.records = data;
  },
  [types.ADD_CRM_CONFIG](_state, data) {
    _state.records.push(data);
  },
  [types.EDIT_CRM_CONFIG](_state, data) {
    const index = _state.records.findIndex(item => item.id === data.id);
    if (index > -1) {
      _state.records.splice(index, 1, data);
    }
  },
  [types.DELETE_CRM_CONFIG](_state, id) {
    const index = _state.records.findIndex(item => item.id === id);
    if (index > -1) {
      _state.records.splice(index, 1);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
